import OptionList from '@/views/custom_select/option_list';
import Switcher from '@/views/switcher';
import asyncSweetScroll from '@/helpers/sweet_scroll';
import makeModal from '@/views/modal/make_modal';
import { isMobile } from '@/helpers/mobile_detect';
import { animatedCollapse, animatedExpand } from '@/helpers/animated';

let nextTariffOptionList = null;
let tariffChangedModal = null;

// the options are rendered into the cached snapshot of the page otherwise, and the next
// visit renders a second set of them over the first
pageUnload('agreements_show', () => {
  nextTariffOptionList?.destroy();
  nextTariffOptionList = null;

  tariffChangedModal?.destroy();
  tariffChangedModal = null;
});

pageLoad('agreements_show', () => {
  const hashParams = new URLSearchParams(window.location.hash.slice(1));

  const defaultSwitcherType = $('.container-profile .b-switcher .is-active[data-switcher_type]')
    .data('switcher_type');
  new Switcher('.container-profile .b-switcher', switcherType => {
    updateSwitcherTypeAnchor(switcherType, defaultSwitcherType);
  });

  if (hashParams.get('switcher_type') === 'info') {
    $('.b-switcher .inner .btn-info').click();
  }

  $('.close-agreement a').on('click', () => {
    $('.b-switcher .inner .btn-info').click();
    asyncSweetScroll('.agreement-close-info');
  });

  $('.pin .skud-password').on('click', ({ currentTarget }) => {
    const $mask = $(currentTarget).find('.mask');
    const $value = $(currentTarget).find('.value');
    $mask.toggleClass('hidden');
    $value.toggleClass('hidden');
  });

  initModalStorageUsageRules();
  initModalNextTariff();
  initModalTariffChanged(hashParams);

  $('.bill-info').on('click', ({ currentTarget, target }) => {
    if (target.tagName === 'BUTTON' || target.tagName === 'A') { return; }

    if (currentTarget.classList.contains('is-expanded')) {
      animatedCollapse(currentTarget.nextSibling);
      currentTarget.classList.remove('is-expanded');
    } else {
      animatedExpand(currentTarget.nextSibling);
      currentTarget.classList.add('is-expanded');
    }
  });
});

pageLoad('agreements_closing', () => {
  initModalStorageUsageRules();
  $('input.confirm').on('change', ({ currentTarget }) => {
    const $checkbox = $(currentTarget);
    const $submit = $('#submit_agreement');
    $submit.prop('disabled', !$checkbox.prop('checked'));
  });
});

function updateSwitcherTypeAnchor(switcherType, defaultSwitcherType) {
  updateHashParam('switcher_type', switcherType === defaultSwitcherType ? null : switcherType);
}

function updateHashParam(name, value) {
  const hashParams = new URLSearchParams(window.location.hash.slice(1));

  if (value) {
    hashParams.set(name, value);
  } else {
    hashParams.delete(name);
  }

  const hash = hashParams.toString();
  const url = window.location.pathname + window.location.search;

  history.replaceState(null, '', hash ? `${url}#${hash}` : url);
}

function initModalNextTariff() {
  const $modal = $('.b-modal-next-tariff');
  if (!$modal.length) { return; }

  const $select = $modal.find('select[name="tariff_months_next"]');

  // the content stays on the server: it is a form posting to a route, and its options carry
  // prices a view object formats
  makeModal({
    node: $modal,
    trigger: $('a.change-tariff'),
    // resetting on the hide would flip the closing modal back to the list in front of the client
    onShow: () => resetTariffChoice($modal, $select)
  });

  // the options are drawn by the same module the custom select draws its dropdown with,
  // only rendered open — the list of the modal has no dropdown chrome
  nextTariffOptionList = new OptionList({
    $select,
    $container: $modal.find('.b-tariff-options'),
    isHtml: true
  });

  $select.on('change', ({ currentTarget }) => {
    if (!isMobile()) { return; }

    showTariffConfirmation($modal, currentTarget.value);
  });

  $modal.find('form').on('submit', event => {
    if (!$modal.hasClass('is-confirmation')) {
      event.preventDefault();
      showTariffConfirmation($modal, $select.val());
      return;
    }

    const $wrapper = $modal.find('.step-confirmation.is-active .b-input-v4');
    const $checkbox = $wrapper.find('input[type=checkbox]');
    if ($checkbox.is(':checked')) { return; }

    event.preventDefault();
    $wrapper.addClass('field_with_errors');
    $checkbox.one('change', () => $wrapper.removeClass('field_with_errors'));
  });

  $modal.find('.step-confirmation .cancel').on('click', () => showTariffOptions($modal));
}

function showTariffConfirmation($modal, months) {
  $modal
    .find('.step-confirmation')
    .removeClass('is-active')
    .filter(`[data-months="${months}"]`)
    .addClass('is-active');
  $modal.addClass('is-confirmation');
}

function showTariffOptions($modal) {
  $modal.removeClass('is-confirmation');
  $modal.find('.step-confirmation').removeClass('is-active');
  $modal.find('.b-input-v4').removeClass('field_with_errors');
  $modal.find('.step-confirmation input[type=checkbox]').prop('checked', false);
}

function resetTariffChoice($modal, $select) {
  showTariffOptions($modal);

  $select.find('option').each((_index, node) => {
    node.selected = node.hasAttribute('selected');
  });
  nextTariffOptionList?.syncCurrentOption();
}

function initModalTariffChanged(hashParams) {
  const node = document.getElementById('modal_tariff_changed');
  if (!node) { return; }
  if (!hashParams.get('tariff_changed')) { return; }

  tariffChangedModal = makeModal({
    cssClass: 'b-modal-tariff is-tariff-changed',
    silhouette: null,
    importComponent: async () => await import('@/vue/modals/tariff_changed'),
    props: JSON.parse(node.dataset.props),
    onHide: () => updateHashParam('tariff_changed', null)
  });

  tariffChangedModal.show();
}

function initModalStorageUsageRules() {
  const $modal = $('.b-modal-storage-usage-rules.is-modal');
  if (!$modal.length) { return; }

  // the trigger lives inside the translations (users.*.yml), not in a template of its own
  makeModal({ node: $modal, trigger: $('a.storage-usage-rules') });
}
